<template>
    <div class="sidebar sidebar-light" style="background-image: url(../assets/logo.png);">
        <div class="sidebar-header">
            <img src="../../src/assets/logo.png" class="logo m-auto" width="180" />
        </div>
        <!-- sidebar-header -->
        <div id="sidebarMenu" class="sidebar-body">
            <div class="nav-group" @click="clearModuleSearch">
                <router-link to="/dashboard" class="nav-label single-label"><i class="ri-pie-chart-2-line"></i>Dashboard</router-link>
            </div>
               <div class="nav-group" @click="clearModuleSearch">
                <router-link to="/users" :class="{'active-parent': isActive('/users')}" class="nav-label single-label" ><i class="ri-group-line"></i>Users</router-link>
            </div>
            <div class="nav-group">
                <a href="javascript:void(0)" class="nav-label"><i class="ri-settings-2-line"></i>Configurations</a>
                <ul class="nav nav-sidebar">
                    <li class="nav-item" @click="clearModuleSearch">
                        <router-link to="/districts" class="nav-link"><i class="ri-pin-distance-line"></i>
                            <span>Districts</span></router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <router-link to="/forms" class="nav-link"><i class="ri-survey-line"></i>
                            <span>Forms</span></router-link>
                    </li> -->
                    <li class="nav-item" @click="clearModuleSearch">
                        <router-link to="/stages" class="nav-link"><i class="ri-bar-chart-line"></i>
                            <span>Stages</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="nav-group" @click="clearModuleSearch">
                <router-link to="/schools" :class="{'active-parent': isActive('/schools')}" class="nav-label single-label"><i class="ri-community-line"></i>Schools</router-link>
            </div>
            <div class="nav-group" @click="clearModuleSearch">
                <router-link to="/attendance" class="nav-label single-label"><i class="ri-contacts-book-2-line"></i>Attendance</router-link>
            </div>
             <div class="nav-group" @click="clearModuleSearch">
                <router-link to="/session_forms" class="nav-label single-label"><i class="ri-file-chart-line"></i>Reports</router-link>
            </div>
            <div class="nav-group" @click="clearModuleSearch">
                <router-link to="/reminders" class="nav-label single-label"><i class="ri-notification-line"></i>    Reminders</router-link>
            </div>
            <div class="sidebar-footer1 bg-light1 nav-group">
                <div class="nav-label single-label" style="padding: 4px 18px; background-color: #e4eddc!important; border-radius: 24px;">
                <img class="" src="../../public/assets/img/tree5.png" style="width:180px;"/>
                </div>
            </div>
        </div>
    </div>
    <!-- sidebar -->
</template>
<script>
export default {
    computed: {
        currentRoute() {
            // console.log("Path--",this.route.path)
            return this.$route.path;
        }
    },
    methods: {
        isActive(route) {
            console.log("route---",route)
            return this.currentRoute.startsWith(route);
        },
        logout() {
            let vm = this;
            vm.$store.dispatch("setUser", null);
            vm.$router.push("/");
        },
        clearSchoolSearch() {
            this.$store.commit("setSchoolSearch", "");
        },
        clearModuleSearch() {
            this.clearSchoolSearch();
            this.$store.dispatch("resetReportSearch");
        }
    },
};
</script>
<style scoped>
.ml-20 {
    margin-left: 20px;
}
.sidebar-body .single-label::after {
    content: ""!important;
    font-family: "remixicon";
    font-size: 14px;
    font-weight: 400;
    position: absolute;
    top: 50%;
    right: 15px;
    line-height: 0;
    opacity: .6;
}
.sidebar-body .nav-group {
    border-bottom: 0px solid !important;
    padding: 4px 18px;
}
.sidebar-light .sidebar-body .nav-label {
    color: #1e1e1e;
    font-size: 0.875rem;
    text-transform: capitalize;
    border-radius: 4px;
}
.router-link-active{
    background-color:#006cb6;
    color: #ffff!important;
}
.nav-sidebar .nav-link {
    color: #1e1e1e;
    display: flex;
    align-items: center;
     border-radius: 4px;
}
.nav-sidebar .nav-lable {
    color: #1e1e1e;
    display: flex;
    align-items: center;
}
 .nav-group .nav-label i{
    margin-right: 12px;
    line-height: 1;
    font-size: 20px;
    width: 18px;
    opacity: .85;
    vertical-align: middle;
 }


.sidebar-footer {
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
    border-top: 1px solid #f3f5f9;
    background-color: #fff;
    z-index: 10;
    box-shadow: -20px -20px 20px #fff;
    transition: all .25s;
}
.sidebar-header {
    padding: 20px;
    height: 100px;
}

.active-parent {
    background-color:#006cb6;
    color: #ffff!important;
}
/* .sidebar.sidebar-light {
    background-image: url('/public/assets/img/rb_32488.png')!important;
    background-size:contain;
    background-position: bottom;
    background-repeat: no-repeat;
    background-color: rgba(255, 255, 255, 0.9);
} */
</style>